<template>
	<v-select
		:multiple="plus"
		:items="options"
		v-bind="$attrs"
		:label="$t('pages.statusSelect')"
		v-model="model"
		item-value="id"/>
</template>

<script>

	import StatusManager from "dev/helpers/StatusManager";


	export default {
		name: "status-select",
		props: {value: {default: null}, plus: {default: false}, hideDuplicate: {default: false}},
		data() {
			return {
				statusArr: [],
				options: null
			};
		},
		computed: {
			model: {
				get() {
					if (this.plus && !Array.isArray(this.value)) {
						return [this.value];
					}
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			},
		},
		created() {
			this.options = null;

			this.options = Object.assign([], StatusManager.status);

			if (this.authIsClient()) {
				this.options = Object.assign([], StatusManager.getClientList());

				if (this.hideDuplicate) {
					this.options.splice(0, 1);
				}
			}
		},
		methods: {
			authIsClient() {
				return this.$store.getters.isClient;
			},
		},

		watch: {
			model: function (newVal, oldVal) {
				return newVal;
			}
		}

	};
</script>







